export default function (value, decimals, str) {
	if (!value) {
		value = 0
	}
	if (!decimals) {
		decimals = 0
	}
	value = str ? value.toFixed(decimals) :
					Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
	return value
}
